<template>
  <div>
    <BaseButton primary @click="setShow(true)"> Delete pipeline </BaseButton>
    <Portal v-if="show" to="app-dialog">
      <VModal ref="modal" @modal:hidden="setShow(false)" disable-backdrop-click>
        <BaseVeeForm
          :action="destroyPipeline"
          v-slot="{ isPending, isRejected, invalid }"
          class="mx-auto max-w-lg"
        >
          <BaseCard @click.stop>
            <BaseCardHeader> Delete pipeline </BaseCardHeader>
            <BaseCardBody>
              <p class="text-gray-600 mb-4">
                Are you sure you want to delete this pipeline? Once a pipeline is deleted, all
                contacts associated with it will be detached.
              </p>
            </BaseCardBody>
            <BaseCardFooter gray>
              <div class="flex space-x-2">
                <BaseButton primary :disabled="isPending || isRejected || invalid">
                  Delete Pipeline
                </BaseButton>
                <BaseButton type="button" ghost @click="setShow(false)"> Cancel </BaseButton>
              </div>
            </BaseCardFooter>
          </BaseCard>
        </BaseVeeForm>
      </VModal>
    </Portal>
  </div>
</template>

<script>
const props = {
  pipelineId: {
    type: String,
    required: true,
  },
};

function data() {
  return {
    show: false,
  };
}

const methods = {
  setShow(value) {
    this.show = Boolean(value);
  },
  async destroyPipeline() {
    try {
      await this.$store.dispatch('ui/pipelines/destroy', {
        pipelineUuid: this.pipelineId,
      });

      this.setShow(false);

      this.$emit('destroyed');

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  props,
  data,
  methods,
};
</script>
